var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 160,
    viewBox: "0 0 216 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.9 0H51.2V159.9H108.9V0Z",
    fill: "#7ADFBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.5 0.100098H214.9C214.9 0.100098 222.4 86.5001 131.6 106H93.2V54.1001H135.9C135.9 54.1001 170 36.8001 161.5 0.100098Z",
    fill: "#8FDDC3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.5 160H214.9C214.9 160 222.4 73.6001 131.6 54.1001H93.2V106H135.9C135.9 106 170 123.3 161.5 160Z",
    fill: "#73E4B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 54.1001V106H128.1C128.1 106 159.4 103.8 183.6 80.1001C183.6 80.1001 166 59.8001 130.2 54.2001H0V54.1001Z",
    fill: "#50C696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.e66a5fb33b715d5ee8d7c15836168559.svg";
export { ForwardRef as ReactComponent };